import { useRef, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { userContext } from './context/userContext';
import { env } from './config/config';

function AcepMaster(props) {
  const acepMaster = useRef();
  const [ssoUser, setSSOUser] = useState(null);
  const { onAcepMasterLoad } = props;
  const location = useLocation();
  let userInfo = useContext(userContext);
  const useGlobalGA = true;
  // Set user properties and handle analytics
  useEffect(() => {
    const currentAcepMaster = acepMaster.current;
    var _ssoUser = null;

    // Only treat the visitor as logged in when we actually have an ACEP id;
    // otherwise leave ssoUser as null so the header shows Sign In/Join instead
    // of a blank member block with a broken avatar.
    if (userInfo?.User?.acepid) {
      var obj = {
        firstName: userInfo.User.firstName,
        acepid: userInfo.User.acepid,
        loginUI_ExpiryDate: userInfo.User.loginUI_ExpiryDate,
        loginUI_Join: userInfo.User.loginUI_Join,
        avatar: userInfo.User.avatar
      };

      _ssoUser = JSON.stringify(obj);
    }

    setSSOUser(_ssoUser);

    // Set user properties for analytics
    if (window.acepGA && userInfo?.User?.acepid && useGlobalGA) {
      const userType = userInfo.User.acepMemberStatus === 2 || userInfo.User.acepMemberStatus === 1 ? 'member' : 'non-member';
      window.acepGA.setUserProperties(userType, userInfo.User.acepid);
    }

    // Call the callback function to notify that AcepMaster is loaded
    if (onAcepMasterLoad) {
      onAcepMasterLoad();
    }

    currentAcepMaster.addEventListener("logout", logout);

    return () => {
      currentAcepMaster.removeEventListener("logout", logout);
    };
  }, [onAcepMasterLoad, userInfo]);

  // Track page views when route changes
  useEffect(() => {
    if (window.acepGA && useGlobalGA) {
      window.acepGA.sendPageView(
        location.pathname === "/" || location.pathname.toLowerCase() === "/dashboard" 
          ? "/Home" 
          : location.pathname,
        location.pathname === "/" || location.pathname.toLowerCase() === "/dashboard" 
          ? "Home"
          : location.pathname.split("/").filter(Boolean).pop() || "Home"
      );
    }
  }, [location]);

  // Set up click handler for data-analytics attributes
  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target;
      const element = target.closest('[data-analytics]');
      
      if (element) {
        const label = element.getAttribute('data-analytics') || "";
        const action = element.getAttribute('data-event') || "click";
         // Compute pageTitle as last segment of pathname
    const pageTitle = location.pathname === "/" || location.pathname.toLowerCase() === "/dashboard"
      ? "Home"
      : location.pathname.split("/").filter(Boolean).pop() || "Home";
        if (action && window.acepGA && useGlobalGA) {
          window.acepGA.trackEvent('CME Dashboard', action.toLowerCase(), label, pageTitle);
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  function logout() {
    //This is called before WC's logout method is called which takes care of SLO
    console.log("L O G O U T called");
    localStorage.clear();
    setSSOUser(null);
  }

  return (
    <acep-master
      ref={acepMaster}
      env={env}
      title="ACEP CME Tracker"
      ssouser={ssoUser}
      useGA={useGlobalGA}
    >
      <div slot="bodySlot">{props.children}</div>
    </acep-master>
  );
}

export default AcepMaster;
